export const trailSectionSlidesSizes = {
  vertical: {
    width: {
      default: 308,
      1366: 222,
      500: 166,
    },
    height: {
      default: 410,
      1366: 296,
      500: 221,
    },
  },
  horizontal: {
    width: {
      default: 308,
      1366: 222,
      500: 166,
    },
    height: {
      default: 173,
      1366: 124,
      500: 93,
    },
  },
};
